
(function(){
'use strict';
const variantMap = {
'8x12-canvas':  '59735354409246',
'8x12-frame':   '59735354573086',
'12x18-canvas': '59735354442014',
'12x18-frame':  '59735354605854',
'16x24-canvas': '59735354474782',
'16x24-frame':  '59735354638622',
'20x30-canvas': '59735354507550',
'20x30-frame':  '59735354671390',
'24x36-canvas': '59735354540318',
'24x36-frame':  '59735354704158'
};
let birdDB = [];
let birdCatalog = null;
let visibleBirdLimit = 60;
const CATALOG_URL = 'https://cdn.shopify.com/s/files/1/0931/5808/0798/files/bird-catalog.json';
const initialLayout=new URLSearchParams(location.search).get('layout')==='3x3'?'3x3':'2x2';
const state={title:"BIRDS I'VE KNOWN",subtitle:'patient watching',layout:initialLayout,maxBirds:initialLayout==='3x3'?9:4,size:'16x24',price:69,type:'canvas',selected:[]};
const priceMap = {'8x12':39,'12x18':45,'16x24':69,'20x30':89,'24x36':109};
const typePriceMap = {canvas:0, frame:20};
const FREE_SHIP_THRESHOLD = 0;
const FLAT_SHIPPING = 0;
const $ = id => document.getElementById(id);
const posterCanvas = $('blc-poster-canvas');
const posterFrame = $('blc-poster-frame');
const posterTitle = $('blc-poster-title');
const posterSubtitle = $('blc-poster-subtitle');
const birdGrid = $('blc-bird-grid');
const sizeBadge = $('blc-size-badge');
const birdList = $('blc-bird-list');
const selectedCount = $('blc-selected-count');
const maxCount = $('blc-max-count');
const orderProduct = $('blc-order-product');
const orderVartype = $('blc-order-vartype');
const orderOrig = $('blc-order-orig');
const orderPrice = $('blc-order-price');
const orderShipping = $('blc-order-shipping');
const addToCartBtn = $('blc-add-to-cart');
const shareStrip = $('blc-share-strip');
const shareUrl = $('blc-share-url');
const toast = $('blc-toast');
function getBirdMatches() {
const query = $('blc-bird-search').value.trim().toLowerCase();
const stateCode = $('blc-state-select').value;
if(query) return birdDB.filter(b => b.name.toLowerCase().includes(query) || b.sci.toLowerCase().includes(query) || b.code.toLowerCase().includes(query));
if(stateCode && birdCatalog){
const region = birdCatalog.states[stateCode];
const codes = birdCatalog.regions[region] || [];
const byCode = new Map(birdDB.map(b => [b.code,b]));
return codes.map(code => byCode.get(code)).filter(Boolean);
}
return birdDB;
}
function syncVisibleSelection() {
birdList.querySelectorAll('.blc-bird-item').forEach(row => {
const chosen = state.selected.some(b => b.code === row.dataset.code);
row.classList.toggle('selected', chosen);
const box=row.querySelector('input'); if(box) box.checked=chosen;
});
}
function renderBirdList(resetLimit) {
if(resetLimit) visibleBirdLimit=60;
const matches=getBirdMatches();
const shown=matches.slice(0,visibleBirdLimit);
birdList.innerHTML='';
shown.forEach((bird) => {
const row=document.createElement('div');
row.className='blc-bird-item';
row.dataset.code=bird.code;
const safeName=bird.name.replace(/&/g,'&amp;').replace(/</g,'&lt;').replace(/"/g,'&quot;');
const safeSci=bird.sci.replace(/&/g,'&amp;').replace(/</g,'&lt;');
row.innerHTML=`<input type="checkbox" aria-label="${safeName}"><img src="${bird.img}" alt="${safeName}" loading="lazy" decoding="async" width="64" height="64" onerror="this.style.opacity='0.25'"><div class="bird-meta"><div class="bird-name">${safeName}</div><div class="bird-sci">${safeSci}</div></div>`;
row.addEventListener('click', e => { if(e.target.type !== 'checkbox'){ row.querySelector('input').click(); return; } toggleBird(bird.code); });
birdList.appendChild(row);
});
if(matches.length > visibleBirdLimit){
const more=document.createElement('button'); more.type='button'; more.className='blc-load-more'; more.textContent=`Show more (${matches.length-visibleBirdLimit} remaining)`;
more.addEventListener('click',()=>{visibleBirdLimit+=60;renderBirdList(false);});
birdList.appendChild(more);
}
if(!matches.length) birdList.innerHTML='<div class="blc-empty">No matching bird found. Try another common or scientific name.</div>';
syncVisibleSelection();
birdList.setAttribute('aria-busy','false');
const query=$('blc-bird-search').value.trim();
const stateCode=$('blc-state-select').value;
$('blc-bird-results').textContent=query ? `${matches.length} matching bird${matches.length===1?'':'s'}` : stateCode ? `${matches.length} common suggestions for ${$('blc-state-select').selectedOptions[0].text}` : `${birdDB.length.toLocaleString()} birds available`;
}
async function loadBirdCatalog() {
try {
const response=await fetch(CATALOG_URL,{credentials:'omit'});
if(!response.ok) throw new Error('Catalog HTTP '+response.status);
birdCatalog=await response.json();
birdDB=birdCatalog.birds.map(b=>({code:b.c,name:b.n,sci:b.s||'',img:b.u}));
birdDB.sort((a,b)=>a.name.localeCompare(b.name));
renderBirdList(true);
} catch(err) {
console.error('Bird catalog failed',err);
birdDB=[];
renderBirdList(true);
$('blc-bird-results').textContent='The bird library could not load. Please refresh and try again.';
}
}
function initBirdList() { renderBirdList(true); }
function toggleBird(code) {
const bird=birdDB.find(b=>b.code===code);
if(!bird) return;
const pos=state.selected.findIndex(b=>b.code===bird.code);
if(pos>=0) state.selected.splice(pos,1);
else {
if(state.selected.length>=state.maxBirds){showToast(`You can pick up to ${state.maxBirds} birds for this layout`);syncVisibleSelection();return;}
state.selected.push(bird);
}
syncVisibleSelection();
refreshAll();
}
function refreshPoster() {
birdGrid.innerHTML = '';
birdGrid.className = `blc-bird-grid layout-${state.layout}`;
for(let i=0; i<state.maxBirds; i++){
const cell = document.createElement('div');
const bird = state.selected[i];
if(bird) {
cell.className = 'blc-bird-cell';
cell.innerHTML = `<img src="${bird.img}" alt="${bird.name}" loading="lazy" decoding="async" width="64" height="64" crossorigin="anonymous" onerror="this.style.display='none';this.parentElement.querySelector('.fallback').style.display='block'"><div class="fallback" style="display:none;font-size:0.65rem;color:#999;text-align:center;padding:3px;">${bird.name}</div><div class="cell-name">${bird.name}</div>`;
} else {
cell.className = 'blc-bird-cell empty';
cell.innerHTML = `<div class="empty-icon">+</div><div class="empty-text">Pick a bird</div>`;
}
birdGrid.appendChild(cell);
}
}
function refreshAll() {
selectedCount.textContent = state.selected.length;
maxCount.textContent = state.maxBirds;
refreshPoster();
updatePrice();
updateButton();
updateShareUrl();
}
function updatePrice() {
const base = priceMap[state.size] || 69;
const extra = typePriceMap[state.type] || 0;
state.price = base + extra;
    var mbPrice = $('blc-mb-price'); if(mbPrice) mbPrice.textContent = '$' + state.price;
const shipping = state.price >= FREE_SHIP_THRESHOLD ? 0 : FLAT_SHIPPING;
const total = state.price + shipping;
orderProduct.textContent = `${state.size.replace('x','" × ')}" Poster`;
orderVartype.textContent = state.type === 'frame' ? 'Black Frame / Gallery wrap' : 'Canvas Print / Gallery wrap';
// No fake "original price" strike-through. Only show strike during a real promotion.
orderOrig.style.display = 'none';
orderPrice.textContent = `$${state.price}`;
if (shipping === 0) {
orderShipping.textContent = 'Free';
orderShipping.style.color = 'var(--accent)';
} else {
orderShipping.textContent = `$${shipping}`;
orderShipping.style.color = 'var(--text)';
}
const typeLabel = state.type === 'frame' ? 'Black Frame' : 'Canvas Print';
sizeBadge.textContent = `${state.size.replace('x','" × ')}" / ${typeLabel}`;
}
function updateButton() {
const need = state.maxBirds, have = state.selected.length;
const nextBtn = $('blc-birds-next');
if(nextBtn){ nextBtn.disabled = have < need; nextBtn.textContent = have < need ? `Pick ${need-have} more to continue` : 'Next: add your title '; }
if(have === 0){ addToCartBtn.disabled = true; addToCartBtn.textContent = `Pick ${need} birds to begin`; }
else if(have < need){ addToCartBtn.disabled = true; addToCartBtn.textContent = `Pick ${need - have} more to begin`; }
else { addToCartBtn.disabled = false; const shipping = state.price >= FREE_SHIP_THRESHOLD ? 0 : FLAT_SHIPPING; const total = state.price + shipping; addToCartBtn.textContent = window.matchMedia('(max-width: 880px)').matches ? 'Review & add to cart - ' + String.fromCharCode(36) + total + ' ' : 'Continue to checkout - ' + String.fromCharCode(36) + total + ' '; }

    var mbAdd = $('blc-mb-add');
    if(mbAdd){
      mbAdd.disabled = addToCartBtn.disabled;
      mbAdd.textContent = addToCartBtn.disabled ? addToCartBtn.textContent : 'Add to cart - $' + (state.price || 69);
    }
}
function updateShareUrl() {
if(state.selected.length === 0){ shareStrip.classList.remove('visible'); return; }
const params = new URLSearchParams({ layout: state.layout, size: state.size, type: state.type, title: state.title, subtitle: state.subtitle, birds: state.selected.map(b => b.code).join(',') });
shareUrl.textContent = `${location.origin}${location.pathname}?${params}`;
shareStrip.classList.add('visible');
}
function showToast(msg) { toast.textContent = msg; toast.classList.add('show'); setTimeout(() => toast.classList.remove('show'), 2800); }
function activateTab(target) {
const tabs = document.querySelectorAll('.blc-tab-btn');
const panels = document.querySelectorAll('.blc-tab-panel');
tabs.forEach(t => t.classList.toggle('active', t.dataset.tab === target));
panels.forEach(p => p.classList.toggle('active', p.dataset.panel === target));
const active = document.querySelector(`.blc-tab-btn[data-tab="${target}"]`);
if(active) active.scrollIntoView({behavior:'smooth',block:'nearest',inline:'center'});
if(window.magtionTrack) window.magtionTrack('customizer_step_viewed',{step:target});
}
function initTabs() {
const tabs = document.querySelectorAll('.blc-tab-btn');
tabs.forEach(tab => tab.addEventListener('click', () => activateTab(tab.dataset.tab)));
if(window.matchMedia('(max-width: 880px)').matches) activateTab('birds');
}
const stateNames='AL:Alabama,AK:Alaska,AZ:Arizona,AR:Arkansas,CA:California,CO:Colorado,CT:Connecticut,DE:Delaware,DC:District of Columbia,FL:Florida,GA:Georgia,HI:Hawaii,ID:Idaho,IL:Illinois,IN:Indiana,IA:Iowa,KS:Kansas,KY:Kentucky,LA:Louisiana,ME:Maine,MD:Maryland,MA:Massachusetts,MI:Michigan,MN:Minnesota,MS:Mississippi,MO:Missouri,MT:Montana,NE:Nebraska,NV:Nevada,NH:New Hampshire,NJ:New Jersey,NM:New Mexico,NY:New York,NC:North Carolina,ND:North Dakota,OH:Ohio,OK:Oklahoma,OR:Oregon,PA:Pennsylvania,RI:Rhode Island,SC:South Carolina,SD:South Dakota,TN:Tennessee,TX:Texas,UT:Utah,VT:Vermont,VA:Virginia,WA:Washington,WV:West Virginia,WI:Wisconsin,WY:Wyoming';
stateNames.split(',').forEach(item=>{const parts=item.split(':');const option=document.createElement('option');option.value=parts[0];option.textContent=parts[1];$('blc-state-select').appendChild(option);});
const birdSearch = $('blc-bird-search');
let searchTimer = null;
    birdSearch.addEventListener('input', () => { clearTimeout(searchTimer); searchTimer = setTimeout(() => renderBirdList(true), 120); });
    /* v2: state chips */
    (function(){
      var chipWrap = $('blc-state-chips');
      if(!chipWrap) return;
      var clearChip = document.createElement('button');
      clearChip.type = 'button'; clearChip.className = 'blc-state-chip active';
      clearChip.textContent = 'All birds'; clearChip.setAttribute('aria-pressed','true');
      chipWrap.appendChild(clearChip);
      stateNames.split(',').forEach(function(item){
        var parts = item.split(':');
        var chip = document.createElement('button');
        chip.type = 'button'; chip.className = 'blc-state-chip';
        chip.textContent = parts[1]; chip.dataset.code = parts[0];
        chip.setAttribute('aria-pressed','false');
        chip.addEventListener('click', function(){
          var sel = $('blc-state-select');
          sel.value = parts[0];
          sel.dispatchEvent(new Event('change'));
          var chips = chipWrap.querySelectorAll('.blc-state-chip');
          for(var j=0;j<chips.length;j++){ chips[j].classList.remove('active'); chips[j].setAttribute('aria-pressed','false'); }
          chip.classList.add('active'); chip.setAttribute('aria-pressed','true');
          if(window.magtionTrack) window.magtionTrack('state_chip_selected',{state:parts[0]});
        });
        chipWrap.appendChild(chip);
      });
      clearChip.addEventListener('click', function(){
        var sel = $('blc-state-select'); sel.value = '';
        sel.dispatchEvent(new Event('change'));
        var chips = chipWrap.querySelectorAll('.blc-state-chip');
        for(var j=0;j<chips.length;j++){ chips[j].classList.remove('active'); chips[j].setAttribute('aria-pressed','false'); }
        clearChip.classList.add('active'); clearChip.setAttribute('aria-pressed','true');
      });
      /* desktop: mouse wheel scrolls the chip row horizontally */
      chipWrap.addEventListener('wheel', function(e){
        if(chipWrap.scrollWidth > chipWrap.clientWidth && e.deltaY){
          e.preventDefault();
          chipWrap.scrollLeft += e.deltaY;
        }
      }, {passive:false});
    })();
    /* v2: quick start presets */
    (function(){
      var backyardBtn = $('blc-preset-backyard');
      var stateBtn = $('blc-preset-state');
      var BACKYARD_CODES = ['norcar','blujay','bkcchi','amegfi'];
      function applyPreset(codes){
        var need = state.maxBirds;
        var picked = codes.slice(0, need);
        var chosen = new Set();
        state.selected.forEach(function(b){ chosen.add(b.code); });
        picked.forEach(function(c){ if(!chosen.has(c)){ var bird = birdDB.find(function(b){ return b.code === c; }); if(bird) state.selected.push(bird); chosen.add(c); } });
        if(state.selected.length > need) state.selected = state.selected.slice(0, need);
        refreshAll();
        if(window.magtionTrack) window.magtionTrack('preset_applied',{type:'backyard'});
      }
      if(backyardBtn) backyardBtn.addEventListener('click', function(){ applyPreset(BACKYARD_CODES); });
      if(stateBtn) stateBtn.addEventListener('click', function(){
        var stateCode = $('blc-state-select').value;
        if(!stateCode || !birdCatalog){ showToast('Pick a state first, then try again.'); return; }
        var region = birdCatalog.states[stateCode];
        var codes = (birdCatalog.regions[region] || []).slice(0, state.maxBirds);
        var birds = codes.map(function(c){ return birdDB.find(function(b){ return b.code === c; }); }).filter(Boolean);
        var chosen = new Set(state.selected.map(function(b){ return b.code; }));
        birds.forEach(function(b){ if(!chosen.has(b.code)){ state.selected.push(b); chosen.add(b.code); } });
        if(state.selected.length > state.maxBirds) state.selected = state.selected.slice(0, state.maxBirds);
        refreshAll();
        if(window.magtionTrack) window.magtionTrack('preset_applied',{type:'state',state:stateCode});
      });
    })();
    /* v2: title examples */
    (function(){
      var exWrap = $('blc-title-examples');
      if(!exWrap) return;
      var btns = exWrap.querySelectorAll('.blc-example');
      for(var i=0;i<btns.length;i++){
        btns[i].addEventListener('click', function(){
          var input = $('blc-input-title');
          input.value = this.dataset.title;
          input.dispatchEvent(new Event('input'));
          if(window.magtionTrack) window.magtionTrack('title_example_used',{title:this.dataset.title});
        });
      }
    })();
$('blc-state-select').addEventListener('change', e => {
birdSearch.value='';
renderBirdList(true);
if(window.magtionTrack && e.target.value) window.magtionTrack('state_bird_suggestions_viewed',{state:e.target.value,result_count:getBirdMatches().length});
});
$('blc-birds-next').addEventListener('click', () => activateTab('title'));
$('blc-input-title').addEventListener('input', e => { state.title = e.target.value || "BIRDS I'VE KNOWN"; posterTitle.textContent = state.title; updateShareUrl(); });
$('blc-input-subtitle').addEventListener('input', e => { state.subtitle = e.target.value || 'patient watching'; posterSubtitle.textContent = state.subtitle; updateShareUrl(); });
document.querySelectorAll('.blc-layout-card').forEach(card => {
card.addEventListener('click', () => {
document.querySelectorAll('.blc-layout-card').forEach(c => { c.classList.remove('active'); c.setAttribute('aria-pressed','false'); });
card.classList.add('active'); card.setAttribute('aria-pressed','true'); state.layout = card.dataset.layout; state.maxBirds = parseInt(card.dataset.count);
if(state.selected.length > state.maxBirds){
state.selected = state.selected.slice(0, state.maxBirds);
renderBirdList(false);
}
refreshAll();
});
});
document.querySelectorAll('.blc-size-chip').forEach(chip => {
chip.addEventListener('click', () => { document.querySelectorAll('.blc-size-chip').forEach(c => { c.classList.remove('active'); c.setAttribute('aria-pressed','false'); }); chip.classList.add('active'); chip.setAttribute('aria-pressed','true'); state.size = chip.dataset.size; refreshAll(); });
});
document.querySelectorAll('.blc-type-card').forEach(card => {
card.addEventListener('click', () => { document.querySelectorAll('.blc-type-card').forEach(c => { c.classList.remove('active'); c.setAttribute('aria-pressed','false'); }); card.classList.add('active'); card.setAttribute('aria-pressed','true'); state.type = card.dataset.type; posterFrame.classList.toggle('framed', state.type === 'frame'); refreshAll(); });
});
document.querySelectorAll('.blc-layout-card, .blc-size-chip, .blc-type-card').forEach(control => {
control.addEventListener('keydown', e => {
if(e.key === 'Enter' || e.key === ' '){ e.preventDefault(); control.click(); }
});
});
$('blc-clear-birds').addEventListener('click', () => {
state.selected = [];
syncVisibleSelection();
refreshAll();
});
function generateThumbnail() {
return new Promise((resolve) => {
const canvas = document.createElement('canvas');
canvas.width = 160; canvas.height = 240;
const ctx = canvas.getContext('2d');
const hasFrame = state.type === 'frame';
const pad = hasFrame ? 10 : 0;
const W = 160 - pad * 2, H = 240 - pad * 2;
if (hasFrame) {
ctx.fillStyle = '#1a1a1a'; ctx.fillRect(0, 0, 160, 240);
ctx.fillStyle = '#faf8f5'; ctx.fillRect(pad, pad, W, H);
ctx.save(); ctx.beginPath(); ctx.rect(pad, pad, W, H); ctx.clip();
} else {
ctx.fillStyle = '#faf8f5'; ctx.fillRect(0, 0, 160, 240);
}
ctx.fillStyle = '#1c1c1c'; ctx.font = 'bold 9px serif'; ctx.textAlign = 'center';
const t = state.title.length > 16 ? state.title.slice(0,14)+'..' : state.title;
ctx.fillText(t.toUpperCase(), pad + W/2, pad + 16);
ctx.font = 'italic 7px serif'; ctx.fillStyle = '#999';
const s = state.subtitle.length > 22 ? state.subtitle.slice(0,20)+'..' : state.subtitle;
ctx.fillText(s, pad + W/2, pad + 26);
ctx.strokeStyle = '#e8e4dc'; ctx.lineWidth = 0.5;
ctx.beginPath(); ctx.moveTo(pad+18, pad+32); ctx.lineTo(pad+W-18, pad+32); ctx.stroke();
const cols = state.layout === '2x2' ? 2 : 3;
const gridW = W - 24, gridH = H - 54;
const sx = pad + 12, sy = pad + 38;
const cellW = gridW / cols, cellH = gridH / (state.maxBirds / cols);
let loaded = 0, total = state.selected.length;
if (total === 0) { if (hasFrame) ctx.restore(); resolve(canvas.toDataURL('image/jpeg', 0.5)); return; }
state.selected.forEach((bird, i) => {
const row = Math.floor(i / cols), col = i % cols;
const cx = sx + col * cellW + 1, cy = sy + row * cellH + 1;
const cw = cellW - 2, ch = cellH - 12;
ctx.strokeStyle = '#e8e4dc'; ctx.lineWidth = 0.5;
ctx.strokeRect(cx, cy, cw, ch + 10);
const img = new Image(); img.crossOrigin = 'anonymous';
img.onload = () => {
const ratio = Math.min((cw-4)/img.width, (ch-4)/img.height);
const w = img.width * ratio, h = img.height * ratio;
ctx.drawImage(img, cx+2+(cw-4-w)/2, cy+2+(ch-4-h)/2, w, h);
ctx.fillStyle = '#999'; ctx.font = '5px sans-serif'; ctx.textAlign = 'center';
ctx.fillText(bird.name.split(' ').pop().slice(0,7), cx+cw/2, cy+ch+6);
loaded++; if (loaded === total) { if (hasFrame) ctx.restore(); resolve(canvas.toDataURL('image/jpeg', 0.5)); }
};
img.onerror = () => {
ctx.fillStyle = '#ccc'; ctx.font = '8px sans-serif'; ctx.textAlign = 'center'; ctx.fillText('?', cx+cw/2, cy+ch/2);
loaded++; if (loaded === total) { if (hasFrame) ctx.restore(); resolve(canvas.toDataURL('image/jpeg', 0.5)); }
};
img.src = bird.img;
});
});
}
addToCartBtn.addEventListener('click', async () => {
if(addToCartBtn.disabled) return;
const activeStep = document.querySelector('.blc-tab-panel.active')?.dataset.panel;
if(window.matchMedia('(max-width: 880px)').matches && activeStep === 'birds'){
activateTab('title');
document.querySelector('.blc-controls')?.scrollIntoView({behavior:'smooth',block:'start'});
showToast('Birds saved - review your title, frame and size.');
if(window.magtionTrack) window.magtionTrack('customizer_review_started',{from_step:'birds'});
return;
}
const variantId = variantMap[`${state.size}-${state.type}`];
if(!variantId){ showToast('Configuration error. Please try again.'); return; }
addToCartBtn.textContent = 'Generating preview...';
addToCartBtn.disabled = true;
let previewImage = '';
try { previewImage = await generateThumbnail(); } catch(e) { console.error('Preview gen failed:', e); }
const shipping = state.price >= FREE_SHIP_THRESHOLD ? 0 : FLAT_SHIPPING;
const properties = {
'_Layout': state.layout,
'Title': state.title,
'Subtitle': state.subtitle,
'Birds': state.selected.map(b => b.name).join(', '),
'_Bird Codes': state.selected.map(b => b.code).join(','),
'_Preview Image': previewImage
};
addToCartBtn.textContent = 'Adding...';
fetch('/cart/add.js', {
method: 'POST',
headers: { 'Content-Type': 'application/json' },
body: JSON.stringify({ id: variantId, quantity: 1, properties: properties })
})
.then(res => { if(!res.ok) throw new Error('Failed'); return res.json(); })
.then(data => {
showToast(`Added! ${state.selected.length} birds / $${state.price + shipping} total`);
document.querySelectorAll('.cart-count, [data-cart-count]').forEach(el => {
const current = parseInt(el.textContent) || 0;
el.textContent = current + 1;
});
setTimeout(() => { window.location.href = '/cart'; }, 1500);
})
.catch(err => {
console.error(err);
showToast('Something went wrong. Please try again.');
updateButton();
});
});
function loadFromUrl() {
const p = new URLSearchParams(location.search);
const layout = p.get('layout'), size = p.get('size'), type = p.get('type');
const title = p.get('title'), subtitle = p.get('subtitle'), birds = p.get('birds');
if(layout) document.querySelector(`[data-layout="${layout}"]`)?.click();
if(size) document.querySelector(`[data-size="${size}"]`)?.click();
if(type) document.querySelector(`[data-type="${type}"]`)?.click();
if(title){ $('blc-input-title').value = title; state.title = title; posterTitle.textContent = title; }
if(subtitle){ $('blc-input-subtitle').value = subtitle; state.subtitle = subtitle; posterSubtitle.textContent = subtitle; }
if(birds){
birds.split(',').forEach(code => {
const idx = birdDB.findIndex(b => b.code === code);
if(idx >= 0 && state.selected.length < state.maxBirds){
const bird = birdDB[idx];
if(!state.selected.find(b => b.code === bird.code)){
state.selected.push(bird);
const row = birdList.children[idx];
if(row){ row.classList.add('selected'); row.querySelector('input').checked = true; }
}
}
});
refreshAll();
}
}
initBirdList();
initTabs();
refreshAll();
loadBirdCatalog().then(loadFromUrl);
    /* v2: mobile bar click */
    (function(){
      var bar = $('blc-mobile-bar'); var mbAdd = $('blc-mb-add');
      if(bar && mbAdd){
        mbAdd.addEventListener('click', function(){
          if(mbAdd.disabled) return;
          addToCartBtn.click();
        });
      }
    })();

})();



(function(){
if(window.__magtionBirdFunnel) return;
window.__magtionBirdFunnel=true;
function track(name,detail){
var payload=Object.assign({event:name,funnel_type:'bird_life_list',product_handle:'my-bird-list-custom-canvas-wall-art',page_path:location.pathname,timestamp:new Date().toISOString()},detail||{});
window.dataLayer=window.dataLayer||[];
window.dataLayer.push(payload);
if(typeof window.clarity === 'function'){ try { window.clarity('event',name); } catch(err){} }
if(window.Shopify && Shopify.analytics && typeof Shopify.analytics.publish === 'function'){
try { Shopify.analytics.publish(name,payload); } catch(err) { console.warn('Shopify analytics publish failed',err); }
}
document.dispatchEvent(new CustomEvent('magtion:funnel',{detail:payload}));
}
window.magtionTrack=track;
track('view_customizer');
document.addEventListener('change',function(e){
if(e.target.matches('#blc-bird-list input[type="checkbox"]')){
var item=e.target.closest('.blc-bird-item');
var count=document.querySelectorAll('#blc-bird-list input[type="checkbox"]:checked').length;
var required=document.querySelector('.blc-layout-card.active')?.dataset.count||'4';
track('bird_selected',{bird_name:item?.querySelector('.bird-name')?.textContent||'',action:e.target.checked?'selected':'removed',selected_count:count,required_count:Number(required)});
if(count===Number(required)) track('bird_selection_completed',{selected_count:count});
}
if(e.target.matches('#blc-input-title,#blc-input-subtitle') && e.target.value.trim()) track('title_completed',{field:e.target.id==='blc-input-title'?'title':'subtitle',value_length:e.target.value.trim().length});
});
document.addEventListener('click',function(e){
var finish=e.target.closest('.blc-type-card');
var size=e.target.closest('.blc-size-chip');
var layout=e.target.closest('.blc-layout-card');
if(finish) track('finish_selected',{finish:finish.dataset.type});
if(size) track('size_selected',{size:size.dataset.size,price:Number(size.dataset.price||0)});
if(layout) track('layout_selected',{layout:layout.dataset.layout,required_count:Number(layout.dataset.count||0)});
if(e.target.closest('#blc-add-to-cart')) track('add_to_cart',{source:'bird_customizer'});
if(e.target.closest('a[href*="/checkout"],button[name="checkout"]')) track('begin_checkout',{source:'bird_customizer'});
},true);
})();
